<template>
    <div class="movemanger">
        <div class="head_warpper">
            <div style="display: flex; align-items: center; justify-content: space-between">
                <div style="display: flex; align-items: center; padding-left: 10px; box-sizing: border-box">
                    <img
                        src="../../../../screenshots/last1.png"
                        :class="prev == null ? 'gray' : ''"
                        style="width: 30px; transform: rotate(180deg)"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : firstPage()"
                    />
                    <img
                        src="../../../../screenshots/next1.png"
                        :class="prev == null ? 'gray' : ''"
                        style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : prevPage()"
                    />
                    <img
                        src="../../../../screenshots/next1.png"
                        :class="next == null ? 'gray' : ''"
                        style="width: 30px; margin-right: 15px"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : nextPage()"
                    />
                    <img
                        src="../../../../screenshots/last1.png"
                        :class="next == null ? 'gray' : ''"
                        style="width: 30px"
                        alt=""
                        @click="isAdd == true || !isedit == true ? '' : lastPage()"
                    />
                </div>
                <div style="float: right">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-printer"
                        :disabled="isAdd || !isedit"
                        @click="labelClick"
                        v-if="perData.allow_add == 1"
                        >{{ $t('common.label') }}</el-button
                    >
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-printer"
                        :disabled="isAdd || !isedit"
                        @click="labelBarcodeDiyClick"
                        v-if="systemSet.isbarcode == 1"
                        >{{ $t('common.barcodelabel') }}</el-button
                    >
                    <el-button type="primary" size="mini" @click="exportFile" :disabled="!isedit">{{ $t('common.export') }}</el-button>
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-plus"
                        :disabled="isAdd || !isedit"
                        @click="add"
                        v-if="perData.allow_add == 1"
                        >{{ $t('common.add') }}</el-button
                    >
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-edit"
                        :disabled="isAdd || !isedit || isCheck || nullBtn"
                        @click="handelEdit"
                        v-if="perData.allow_edit == 1"
                        >{{ $t('common.edit') }}</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        :disabled="isAdd || !isedit || isCheck || nullBtn"
                        @click="delMove"
                        v-if="perData.allow_dele == 1"
                        >{{ $t('common.delete') }}</el-button
                    >
                    <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                    <el-button
                        type="primary"
                        size="mini"
                        :disabled="isAdd || !isedit || nullBtn"
                        @click="printOut"
                        v-if="perData.allow_print == 1"
                        icon="el-icon-printer"
                        >{{ $t('common.print') }}</el-button
                    >
                    <el-button
                        type="primary"
                        v-if="perData.allow_check == 1"
                        :disabled="isAdd || !isedit || nullBtn"
                        plain
                        @click="isEdit()"
                        >{{ form.check == 1 ? $t('common.cancelAudit') : $t('common.audit') }}</el-button
                    >
                </div>
            </div>

            <div class="top_col">
                <el-row :gutter="30">
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{
                                form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                            }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="top_cols">
                <el-form :model="form">
                    <el-row :gutter="30">
                        <el-col :span="4">
                            <el-form-item :label="$t('common.billNo') + '：'">
                                <el-input v-model="form.movesj_no" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('common.billDate') + '：'">
                                <el-date-picker
                                    type="datetime"
                                    :disabled="isedit"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期"
                                    v-model="form.movesj_date"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label="$t('common.billType') + '：'">
                                <el-select
                                    v-model="form.billtype_no"
                                    clearable
                                    filterable
                                    @visible-change="getRefreshPull()"
                                    placeholder="请选择"
                                    :disabled="isedit"
                                >
                                    <el-option
                                        v-for="(item, index) in allArr.billtype"
                                        :key="index"
                                        :label="item.billtype_no + ' - ' + item.billtype_name"
                                        :value="item.billtype_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" v-if="systemSet.isstores == 1">
                            <div class="input_col">
                                <el-form-item :label="$t('common.store') + '：'">
                                    <mySelect
                                        v-model="form.store_no"
                                        :options="allArr.store"
                                        values="store_no"
                                        labels="store_name"
                                        keys="store_no"
                                        :disable="isedit"
                                        :clearables="false"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4" v-if="systemSet.isstores == 1">
                            <div class="input_col">
                                <el-form-item label="调入门店：">
                                    <el-select
                                        v-model="form.instore_no"
                                        clearable
                                        default-first-option
                                        filterable
                                        placeholder="请选择"
                                        :disabled="isedit"
                                        @change="changeInstore"
                                    >
                                        <el-option
                                            v-for="(item, index) in allArr.instore"
                                            :key="index"
                                            :label="item.instore_no + ' - ' + item.instore_name"
                                            :value="item.instore_no.toString()"
                                            :disabled="item.status == 0"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5">
                        <el-col>
                            <el-input
                                type="textarea"
                                :rows="1"
                                v-model="form.remark"
                                placeholder="请输入备注"
                                :disabled="isedit"
                            ></el-input>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="table1" @mouseleave="dtlleave">
            <div class="title">
                <div style="text-align: left; color: #000; font-size: 16px; padding: 6px 0">{{ $t('common.productDetail') }}</div>
                <div style="padding-right: 20px; display: flex">
                    <el-button
                        type=""
                        :disabled="isedit"
                        @click="showImpotDialogtmdr = true"
                        v-if="systemSet.isbarcode == 1 || systemSet.isgoldsilver == 1"
                        >条码导入</el-button
                    >
                    <el-button type="" :disabled="isedit" @click="showImpotDialog = true">导入</el-button>
                    <el-input style="margin-left: 10px" placeholder="请输入引用单号" v-model="sepwgtOrder" clearable :disabled="isedit">
                    </el-input>
                    <el-button type="primary" style="margin-left: 10px" @click="getSepwgtOrderInfo" :disabled="isedit">确认</el-button>
                </div>
            </div>
            <vxe-table
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                height="420"
                show-overflow
                highlight-hover-row
                :loading="loading"
                show-footer-overflow
                :edit-rules="validRules"
                :footer-method="footerMethod"
                show-footer
                :keyboard-config="{
                    isArrow: true,
                    isDel: true,
                    isEdit: true
                }"
                :row-class-name="rowChange"
                :data="form.dtl"
                :mouse-config="{ selected: true }"
                :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                @cell-click="choseIt"
                @cell-mouseenter="dtlenter"
                :key="refushTable"
                :scroll-y="{ enabled: true, gt: 50 }"
                @checkbox-change="checkboxChangeEvent"
                @checkbox-all="checkboxChangeEvent"
            >
                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                <vxe-table-column type="seq" field="seq" width="70" title="序号">
                    <template slot="header">
                        <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                    </template>
                    <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                            <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                            <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                        </span>
                        <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                    </template>
                </vxe-table-column>
                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                        v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select' &&
                            item.field == 'wgt' ||
                            item.field == 'qty' || 
                            item.field == 'alloy' || 
                            item.field == 'remark'
                        "
                    >
                        <template #header="{ column }" v-if="item.batch == 1">
                            <span>{{ column.title }}</span>
                            <el-dropdown trigger="click" :hide-on-click="flagFalse">
                                <el-button
                                    class="batchBtn"
                                    type="primary"
                                    plain
                                    :disabled="isedit || item.column_disabled == 1"
                                    @click="iptbatchClick"
                                    >批量</el-button
                                >
                                <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                    <el-radio-group v-model="iptbatchOption">
                                        <div style="display: flex">
                                            <div style="margin-right: 10px">
                                                <div style="">
                                                    <el-radio label="1">所有行修改为</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="2">选中行及以下行修改为</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="5">选中行修改为</el-radio>
                                                </div>
                                            </div>

                                            <div style="margin-right: 10px">
                                                <div style="">
                                                    <el-radio label="3">所有行加减</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="4">选中行及以下行加减</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="6">选中行加减</el-radio>
                                                </div>
                                            </div>
                                        </div>
                                    </el-radio-group>
                                    <div style="padding-top: 5px"></div>
                                    <el-form :inline="true">
                                        <el-form-item label="">
                                            <vxe-input
                                                style="width: 280px"
                                                :type="item.column_type"
                                                v-model="iptBatchSelect"
                                                @blur="iptBatchOperation($event, column.property)"
                                            ></vxe-input>
                                        </el-form-item>
                                    </el-form>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                type="text"
                                @input="handleInput(row, item.field, item.column_type)"
                                @keydown.native="jumptable($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                :disabled="item.column_disabled == 1"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        :title="item.column_name"
                        class-name="jump"
                        v-if="item.field == 'barcode' && item.column_status == 1"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                    >
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                type="text"
                                @input="handleInput(row, item.field, item.column_type)"
                                @keydown.native="barcodeJump($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                        v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select' &&
                            item.field != 'amt' &&
                            item.field != 'outcounter_no' &&
                            item.field != 'incounter_no' &&
                            item.field != 'barcode' &&
                            item.field != 'trans_wgt' &&
                            item.field != 'wgt' &&
                            item.field != 'qty' &&
                            item.field != 'alloy' &&
                            item.field != 'remark' 
                        "
                    >
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                type="text"
                                @input="handleInput(row, item.field, item.column_type)"
                                @keydown.native="jumptable($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        v-if="
                            item.column_status == 1 &&
                            item.column_type == 'select' &&
                            item.field != 'outcounter_no' &&
                            item.field != 'incounter_no'
                        "
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                $selectLable.selectLable(
                                    row[item.field],
                                    allArr[item.field.replace('_no', '')],
                                    item.field,
                                    item.field.replace('_no', '_name')
                                )
                            }}</span>
                        </template>
                        <template v-slot:edit="{ row }">
                            <el-select
                                size="mini"
                                v-model="row[item.field]"
                                ref="stylefocus"
                                filterable
                                default-first-option
                                placeholder="请选择"
                                @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                @keydown.native="jumptable($event, row, item.field)"
                            >
                                <el-option
                                    v-for="option in allArr[item.field.replace('_no', '')] || []"
                                    :key="option[item.field.replace('_no', '') + '_no']"
                                    :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                    :value="option[item.field.replace('_no', '') + '_no']"
                                    :disabled="option.status == 0"
                                ></el-option>
                            </el-select>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        v-if="item.field == 'outcounter_no' && item.column_status == 1"
                        title="调出柜台"
                        field="outcounter_no"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                $selectLable.selectLable(row.outcounter_no, allArr.outcounter, 'outcounter_no', 'outcounter_name')
                            }}</span>
                        </template>
                        <template #header="{ column }">
                            <span>{{ column.title }}</span>
                            <el-dropdown trigger="click">
                                <el-button type="primary" class="batchBtn" plain :disabled="isedit" @click="batchclick">批量</el-button>
                                <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                    <el-radio-group v-model="batchOption">
                                        <el-radio label="1">修改所有行</el-radio>
                                        <el-radio label="2">修改选中行及以下行</el-radio>
                                    </el-radio-group>
                                    <div style="padding-top: 5px"></div>
                                    <el-form :inline="true">
                                        <el-form-item label="修改为：">
                                            <mySelect
                                                v-model="batchSelect"
                                                :options="allArr.outcounter"
                                                values="outcounter_no"
                                                labels="outcounter_name"
                                                keys="outcounter_no"
                                                @selectChange="batchOperation($event, column.property)"
                                                :disable="isedit"
                                            />
                                        </el-form-item>
                                    </el-form>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template v-slot:edit="{ row }">
                            <mySelect
                                v-model="row.outcounter_no"
                                :options="allArr.outcounter"
                                values="outcounter_no"
                                labels="outcounter_name"
                                keys="outcounter_no"
                                :disable="isedit"
                                @keydown.native="jumptable($event, row, item.field)"
                            />
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        v-if="item.field == 'incounter_no' && item.column_status == 1"
                        title="调入柜台"
                        field="incounter_no"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                $selectLable.selectLable(row.incounter_no, allArrStore.incounter, 'incounter_no', 'incounter_name')
                            }}</span>
                        </template>

                        <template #header="{ column }">
                            <span>{{ column.title }}</span>
                            <el-dropdown trigger="click">
                                <el-button class="batchBtn" type="primary" plain :disabled="isedit" @click="batchclick">批量</el-button>
                                <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                    <el-radio-group v-model="batchOption">
                                        <el-radio label="1">修改所有行</el-radio>
                                        <el-radio label="2">修改选中行及以下行</el-radio>
                                    </el-radio-group>
                                    <div style="padding-top: 10px"></div>
                                    <el-form :inline="true">
                                        <el-form-item label="修改为：">
                                            <mySelect
                                                v-model="batchSelect"
                                                :options="allArrStore.incounter"
                                                values="incounter_no"
                                                labels="incounter_name"
                                                keys="incounter_no"
                                                @selectChange="batchOperation($event, column.property)"
                                                :disable="isedit"
                                            />
                                        </el-form-item>
                                    </el-form>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template v-slot:edit="{ row }">
                            <mySelect
                                v-model="row.incounter_no"
                                :options="allArrStore.incounter"
                                values="incounter_no"
                                labels="incounter_name"
                                keys="incounter_no"
                                :disable="isedit"
                                @keydown.native="jumptable($event, row, item.field)"
                            />
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                            title="折足重"
                            field="trans_wgt"
                            :edit-render="{}"
                            class-name="jump"
                            :width="item.column_width"
                            v-if="item.field == 'trans_wgt' && item.column_status == 1"
                            :key="item.field + index"
                        >
                            <template v-slot:edit="{ row }">
                                <span>{{ counttranswgt(row).toFixed(systemSet.wgt) }}</span>
                            </template>
                        </vxe-table-column>

                    <vxe-table-column
                        title="金额"
                        v-if="item.field == 'amt' && item.column_status == 1"
                        field="amt"
                        :width="item.column_width"
                        :key="item.field + index"
                        class-name="jump"
                        :edit-render="{}"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countAmount(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                </template>
                <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                </template>
            </vxe-table>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="调拨数量：">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item label="调拨重量：">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item label="调拨金额：">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.movesj_no)" style="width: 73px">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItMove">{{ $t('common.save') }}</el-button>
            </div>
        </div>

        <!-- 放大图片 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <!-- 筛选弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.filter')" :visible.sync="outData.isshow" width="60%">
            <div class="box1">
                <el-button type="success" icon="el-icon-plus" plain circle @click="showInput"></el-button>
                <div
                    style="margin-top: 20px; display: flex; flex-wrap: wrap; align-items: center"
                    v-for="(tag, index) in bonusData.field"
                    :key="index"
                >
                    <el-select
                        filterable
                        @change="selectOne(index)"
                        v-model="bonusData.field[index]"
                        clearable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in allArr.screen_pull"
                            :key="item.style_no"
                            :label="item.table_name"
                            :value="item.table"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select
                        filterable
                        @change="selectOne1(index)"
                        v-model="bonusData.table[index]"
                        clearable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in allArr.screen_pull[arr[index] ? arr[index] : 0].field"
                            :key="item.name_no"
                            :label="item.name"
                            :value="item.name_no"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select filterable v-model="bonusData.condition[index]" clearable default-first-option placeholder="请选择">
                        <el-option
                            v-for="item in allArr.screen_condition"
                            :key="item.name_no"
                            :label="item.name"
                            :value="item.name_no"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select
                        filterable
                        v-if="allArr.screen_pull[arr[index] ? arr[index] : 0].field[arrs[index] ? arrs[index] : 0].select"
                        v-model="bonusData.parameter[index]"
                        clearable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in allArr.screen_pull[arr[index] ? arr[index] : 0].field[arrs[index] ? arrs[index] : 0].select"
                            :key="item.kind_no"
                            :label="item.kind_name"
                            :value="item.kind_no"
                            :disabled="item.status == 0"
                        ></el-option>
                    </el-select>
                    <el-input style="width: 20%" v-else v-model="bonusData.parameter[index]" placeholder="请输入"></el-input>
                    <el-button
                        style="margin-left: 15px"
                        type="danger"
                        icon="el-icon-minus"
                        plain
                        circle
                        @click.native.prevent="deleteRow(index, bonusData)"
                        size="small"
                    ></el-button>
                </div>
            </div>
            <el-table v-if="searchData.length" :data="searchData" style="width: 100%; margin-top: 20px">
                <el-table-column prop="movesj_no" label="调拨单号"></el-table-column>
                <el-table-column prop="in_c.kind_name" label="调入柜台"></el-table-column>
                <el-table-column prop="out_c.kind_name" label="调出柜台"></el-table-column>
                <el-table-column prop="total.qty" label="数量"></el-table-column>
                <el-table-column prop="total.wgt" label="重量"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" plain icon="el-icon-edit" @click="searchIt(scope.row.movesj_no)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveOk">确 定</el-button>
                <el-button @click="outData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 导出弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.export')" :visible.sync="excelData.isshow" width="60%">
            <div class="pro" style="text-align: center">
                <el-select
                    style="display: block; width: 50%; margin: 0 auto"
                    v-model="excelValue"
                    clearable
                    default-first-option
                    placeholder="请选择"
                >
                    <el-option label="调拨" value="调拨">调拨</el-option>
                    <el-option label="调拨明细" value="调拨明细">调拨明细</el-option>
                </el-select>
                <el-input style="display: block; width: 50%; margin: 10px auto" v-model="keyword" placeholder="请输入调拨单号"></el-input>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="in_counter"
                    v-if="excelValue == '调拨'"
                    placeholder="请选择调入柜台"
                >
                    <el-option
                        v-for="(item, index) in allArr.counter"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                    ></el-option>
                </el-select>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="out_counter"
                    v-if="excelValue == '调拨'"
                    placeholder="请选择调出柜台"
                >
                    <el-option
                        v-for="(item, index) in allArr.counter"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '调拨'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="subscribe_date"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="style_no"
                    v-if="excelValue == '调拨明细'"
                    placeholder="请选择产品"
                >
                    <el-option
                        v-for="(item, index) in allArr.style"
                        :key="index"
                        :label="item.style_name"
                        :value="item.style_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: flex; align-items: center; margin-top: 30px; justify-content: center">
                    <el-button style="margin-left: 10px" type="success" icon="el-icon-download" @click="outExcel">{{ $t('common.export') }}</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="outTem">模板导出</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="excelData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints" style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList" style="page-break-after: always; margin-bottom: 30px" :key="index">
                    <div
                        style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                        v-if="DataDtl.company.is_show == 1"
                    >
                        <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>

                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" v-if="itemBig.billtype_info" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.billtype_info.billtype_name }}
                            </p>
                        </div>
                    </div>
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                                <div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户：<span v-if="itemBig.cust_info">{{ itemBig.cust_info.cust_name }}</span>
                                    </div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">备注：{{ itemBig.remark }}</div>
                                </div>
                                <div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">单号：{{ itemBig.movesj_no }}</div>
                                    <div :style="`font-size:${DataDtl.header.font_size}px;`">日期：{{ itemBig.movesj_date }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.is_fields1 == 1" :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`">
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtl_report" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.name == '调出柜台'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.name == '调入柜台'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no]|| '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.name == '产品'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item.style_info[items.no] || '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table1_total_show == 1">
                                <template v-for="(items, indexs) in fields1">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtl_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="itemBig.dtlGroupBy && DataDtl.is_fields2 == 1" :style="`margin-bottom:${DataDtl.table2_bottommargin}px;`">
                        <p class="tableName">
                            <span v-if="DataDtl.table_name2_show == 1">{{ DataDtl.table_name2 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields2_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields2">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtlGroupBy" :key="index">
                                <template v-for="items in fields2">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table2_total_show == 1">
                                <template v-for="(items, indexs) in fields2">
                                    <template v-if="indexs == 0"
                                    ><td
                                        :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        :key="items.seq"
                                    >
                                        合计
                                    </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtlGroupBy_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="oversummoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">总计 金额大写 {{ itemBig.money_type }}</span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.money_chinese }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                        >金额合计&nbsp;&nbsp;&nbsp; {{ itemBig.money_type }}
                                    </span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.money }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span v-if="itemBig.build_has">{{ itemBig.build_has.staffr_name }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span v-if="itemBig.salesman_report">{{ itemBig.salesman_report.staffr_name }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>
                            <div style="display: inline-block; text-align: right; width: 20%">
                                <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 10px" v-if="DataDtl.remark.is_show == 1">
                        <p :style="`font-size:${DataDtl.remark.font_size}px;`">{{ DataDtl.remark.content }}</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <!-- <img style="margin-top:20px;" :src="img" alt=""> -->
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 审核弹出框 -->
        <el-dialog style="padding: 0 20px" title="批量审核" :visible.sync="checkData.isshow" width="60%">
            <el-form label-width="100px">
                <el-form-item label="开始日期">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="checkData.data.begin_date"
                        style="width: 100%"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="checkData.data.end_date"
                        style="width: 100%"
                    ></el-date-picker>
                </el-form-item>
                <div style="text-align: center">
                    <el-button type="success" @click="saveCheck('1')" style="margin-right: 30px">审 核</el-button>
                    <el-button type="warning" @click="saveCheck('0')">反审核</el-button>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="dialogFormVisible" width="35%">
            <div class="printBox" id="prints" ref="prints">
                <div v-for="(item, index) in LabelList" style="page-break-after: always; padding: 0px; margin-bottom: 15px">
                    <div>产品名称:{{ item.style_name ? item.style_name : '' }}</div>
                    <div style="display: flex">
                        <div style="margin-right: 10px">
                            <div>调出柜台:{{ item.outcounter_name ? item.outcounter_name : '' }}</div>
                            <div>数量:{{ item.qty ? item.qty : '' }}</div>
                        </div>
                        <div>
                            <div>调入柜台:{{ item.incounter_name ? item.incounter_name : '' }}</div>
                            <!-- <div>&emsp;</div> -->
                            <div>重量:{{ item.wgt ? item.wgt : '' }}</div>
                        </div>
                    </div>
                    <div>&emsp;</div>
                    <div>本标签重0.1g</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleModify()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialog" width="45%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTemdr">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'import_movesj'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="条码导入明细" :visible.sync="showImpotDialogtmdr" width="45%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTemtmdr">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        :data="uploadData"
                        drag
                        :action="this.$baseURL + 'import_movesj'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialogtmdr = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialogtmdr = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiFirstMove,
    apiSearchMove,
    apiLastMove,
    apiNextMove,
    apiGetinfo,
    apiPrevMove,
    apiAllSelectMove,
    apiModifyMove,
    apiaddMove,
    apiDelMove,
    apiCurrentPermisson,
    apicheckMove,
    apichooseMove,
    apiSystem,
    apiCounterTable,
    apiPrintMover,
    apiMoverAllCheck,
    getPrinOut_pull,
    apiPrintmovesjprintLabel,
    setScale,
    apiGetMoveBarcodeInfo,
    apiIsAllowUpdateMoveData,
    apiUseSepwgtMovesj,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiAllSelectincountpull,
    apiCustStyleWage,
    apiLabelPrintPrintBarcodes
} from '@/request/api';
import print from 'print-js';
import html2canvas from 'html2canvas';
import VXETable from 'vxe-table';
import { getExportExcel } from '@/utils/multAdexportExcel.js';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'movemanage',
    data() {
        return {
            uploadData: {
                type: '条码'
            },
            LabelList: {},
            headers: {},
            showImpotDialog: false,
            showImpotDialogtmdr: false,
            dialogFormVisible: false,
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            printType: '',
            bonusData: { field: [], table: [], condition: [], parameter: [] },
            tableIndex: 0,
            tableNo: 0,
            searchData: [],
            arr: [],
            arrs: [],
            in_counter: '',
            out_counter: '',
            style_no: '',
            subscribe_date: '',
            tableData: [],
            activeName: 'first',
            allArr: '',
            allArrStore: [],
            form: {},
            isedit: true,
            isCheck: false,
            prev: null,
            next: null,
            dialogImageUrl: '',
            dialogVisible: false,
            outData: { isshow: false, scope: null, index: 0, data: {} },
            excelData: { isshow: false, scope: null, index: 0, data: {} },
            printData: { isshow: false, scope: null, index: 0, data: {} },
            checkData: { isshow: false, scope: null, index: 0, data: {} },
            keyword: '',
            isAdd: false,
            loading: false,
            excelValue: '',
            imgArr: [],
            pull_counter: [],
            pull_counter2: [],
            usedCounter: '',
            nullBtn: false,
            selectNum: '',
            systemSet: JSON.parse(localStorage.getItem('systemSet')),
            username: '',
            printList: {},
            printDtl: [],
            outC: '',
            inC: '',
            checkHas: '',
            dtlTotal: '',
            dtlIndex: '-1', //列表当前位置,
            validRules: {
                style_no: [{ required: true, message: '产品必须填写' }],
                outcounter_no: [{ required: true, message: '调出柜台必须填写' }],
                incounter_no: [{ required: true, message: '调入柜台必须填写' }]
            },
            isSave: true,
            batchSelect: '',
            selectRecords: 0,
            batchOption: '1',
            sepwgtOrder: '',
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '18',
            perData: {}, //权限
            flagFalse:false,
            iptbatchOption: '1',
            iptBatchSelect: '',
        };
    },
    mounted() {
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    created() {
        // this.getSystem();
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        // this.geData();
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.searchIt(bill_no);
        } else {
            this.geData();
        }
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        this.getPulls();
        this.getTable();
        this.getStoneData();
        this.getPermission();
        document.addEventListener('keydown', this.mykeyup);
    },
    activated() {
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            }
        }
    },
    watch: {},
    methods: {
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/movemanage') {
                        this.saveItMove();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        handleClose() {
            this.showImpotDialog = false;
        },
        // 拖拽成功的钩子
        uploadSuccess(res) {
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.form.dtl = res.data;
                this.showImpotDialog = false;
                this.showImpotDialogtmdr = false;
            } else {
                if (res.data.info instanceof Array) {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i] + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                } else {
                    this.$message.success(res.data.info);
                }
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTemdr() {
            this.$axios
                .get(`${this.$baseURL}template_export_movesj`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        outTemtmdr() {
            this.$axios
                .get(`${this.$baseURL}template_export_movesj`, {
                    params: {
                        token: this.token,
                        type: '条码'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '条码明细导入模板.xls';
                    link.click();
                });
        },
        // 获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiLastMove({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    }
                    if (res.data.data.dtl[0]) {
                        var arr = [];
                        for (let i in res.data.data.dtl[0].style_img) {
                            if (res.data.data.dtl[0].style_img[i]) {
                                arr.push(res.data.data.dtl[0].style_img[i]);
                            }
                        }
                        this.imgArr = arr;
                    }
                } else {
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [], selCounter: [] };
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
                this.getStore();
            });
            loading.close();
        },
        barcodeJump(e, row, type) {
            if (e.keyCode == '13' || e.keyCode == '9' || e.keyCode == '39') {
                // 阻止默认行为
                e.preventDefault();
                // 所有行数据
                var rows = this.$refs.xTable1.getTableData().fullData;
                // 根据当前行获取行下标
                var rowIndex = this.$refs.xTable1.getVTRowIndex(row);
                let backRow = this.$refs.xTable1.getTableData().tableData[row.seq - 1];
                let allowBreak = true;
                rows.forEach((item, index) => {
                    if (index === rowIndex) {
                        return;
                    }
                    if (item.barcode && item.barcode == row.barcode) {
                        this.$message.error('条码号不能重复');
                        row.barcode = '';
                        allowBreak = false;
                    }
                });
                if (!allowBreak) {
                    setTimeout(() => {
                        this.$refs.xTable1.setActiveCell(backRow, 'barcode');
                    }, 300);
                    return;
                }
                let data = {
                    barcode: e.target.value.trim(),
                    counter_no: row.outcounter_no
                };
                apiGetMoveBarcodeInfo(data).then((res) => {
                    if (res.code === 2000) {
                        for (var item in res.data) {
                            row[item] = res.data[item];
                        }
                        //最后一列换行
                        if (rowIndex + 1 == rows.length) {
                            // 最后一行 先增加行在换行
                            this.adddtl();
                            // 换行
                            setTimeout(() => {
                                let rowDatas = this.$refs.xTable1.getTableData().fullData;
                                rowDatas[rowIndex + 1].outcounter_no = backRow.outcounter_no;
                                rowDatas[rowIndex + 1].incounter_no = backRow.incounter_no;
                                this.$refs.xTable1.setActiveRow(rowDatas[rowIndex + 1]);
                            }, 100);
                        } else {
                            rows[rowIndex + 1].outcounter_no = backRow.outcounter_no;
                            rows[rowIndex + 1].incounter_no = backRow.incounter_no;
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }
                    } else {
                        row.barcode = '';
                        this.$refs.xTable1.setActiveCell(backRow, 'barcode');
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        batchclick() {
            this.batchSelect = '';
        },
        batchOperation(e, r) {
            var table1 = this.$refs.xTable1.getTableData().fullData;
            if (this.batchOption == '1') {
                for (let i = 0; i < table1.length; i++) {
                    table1[i][r] = e;
                }
            } else if (this.batchOption == '2') {
                let selectedRowIndex = --this.selectRecords[0].seq;
                for (let i = selectedRowIndex; i < table1.length; i++) {
                    table1[i][r] = e;
                }
            }
        },
        iptbatchClick(){
            this.iptBatchSelect = '';
        },
        iptBatchOperation(e, r){
            if (e.value) {
                let table1 = this.$refs.xTable1.getTableData().fullData;
                if (this.iptbatchOption == '1') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.iptbatchOption == '2') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.iptbatchOption == '3') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.iptbatchOption == '4') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.iptbatchOption == '5') {
                    // 处理多个选中的行修改为指定值
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            table1[selectedRowIndex][r] = e.value; // 修改选中行的指定列值
                        }
                    }
                } else if (this.iptbatchOption == '6') {
                    // 处理多个选中的行加减
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            // 对选中行进行加减
                            table1[selectedRowIndex][r] = Number(table1[selectedRowIndex][r]) + Number(e.value);
                        }
                    }
                }
                for (let i = 0; i < table1.length; i++) {
                    this.counttranswgt(table1[i])
                    this.countAmount(table1[i])
                }
                this.$refs.xTable1.reloadData(table1)
                this.flagFalse = false;
            }
        },
        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },
        getSepwgtOrderInfo() {
            if (this.sepwgtOrder.trim() == '') {
                this.$message.info('请先输入引用单号再确认');
                return;
            }
            apiUseSepwgtMovesj({ bill_no: this.sepwgtOrder }).then((res) => {
                if (res.code === 2000) {
                    this.form.dtl = res.data;
                    this.sepwgtOrder = '';
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        changeInstore(e) {
            this.$forceUpdate();
            this.getStore();
        },
        getStore() {
            apiAllSelectincountpull({ instore_no: this.form.instore_no }).then((res) => {
                this.allArrStore = res.data;
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiAllSelectMove({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_counter = res.data.outcounter;
                    this.pull_counter2 = res.data.incounter;
                    this.usedCounter = res.data.user_counter;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //搜索-----------------------------------------------------
        searchIt(no) {
            this.isedit = true;
            apiSearchMove({
                movesj_no: no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    this.outData.isshow = false;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        exportFile() {
            getExportExcel('billexport_movesj', { movesj_no: this.form.movesj_no }, '调拨管理');
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            if (no == null) {
                this.geData();
            } else {
                this.searchIt(no);
            }
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/movemanage');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            apiIsAllowUpdateMoveData({ movesj_no: this.form.movesj_no }).then((res) => {
                if (res.code === 2000) {
                    if (this.isedit == true) {
                        if (this.form.check == 0) {
                            this.isedit = false;
                            if (this.form.dtl.length == 0) {
                                this.insertEvent(-1);
                            }
                        } else if (this.form.check == 1) {
                            this.isCheck = true;
                        }
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 保存修改------------------------------------------
        // 效验数据
        // async validEvent() {
        //     const $table = this.$refs.xTable1;
        //     const errMap = await $table.validate().catch(errMap => errMap);
        //     if (errMap) {
        //         VXETable.modal.message({ status: 'error', content: '校验不通过！' });
        //     } else {
        //         VXETable.modal.message({ status: 'success', content: '校验成功！' });
        //     }
        // },
        async saveItMove() {
            // const $table = this.$refs.xTable1;
            // const errMap = await $table.validate().catch((errMap) => errMap);
            // if (errMap) {
            //     VXETable.modal.message({ status: 'error', content: '请输入必填信息后保存' });
            //     return;
            // }
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                data['dtl'] = table1;
                data['check'] = this.form.check == true ? 1 : 0;
                this.$load.show();
                if (this.isAdd == true) {
                    apiaddMove(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/movemanage');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyMove(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { movesj_date: '', stock: [] };
                this.imgArr = [];
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.movesj_date = this.$getTime();
                this.form.remark;
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                if (this.usedCounter) {
                    this.form.in_counter = this.usedCounter.intcounter_no;
                    this.form.out_counter = this.usedCounter.outcounter_no;
                    if (this.form.counter_no) {
                        this.selCounter();
                    }
                }
                this.getStore();
                setTimeout(() => {
                    for (let i = 0; i < 3; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除产品-----------------------------------------
        delMove() {
            apiIsAllowUpdateMoveData({ movesj_no: this.form.movesj_no }).then((res) => {
                if (res.code === 2000) {
                    this.$confirm('确定要删除该调拨管理单吗？', '提示', {
                        type: 'warning'
                    })
                        .then(() => {
                            apiDelMove({
                                movesj_no: this.form.movesj_no
                            }).then((res) => {
                                if (res.code == 2000) {
                                    this.$message({ message: '删除成功', type: 'success' });
                                    if (res.data.data == null) {
                                        this.form = {};
                                        this.nullBtn = true;
                                    } else {
                                        this.form = res.data.data;
                                        if (this.form.check == 1) {
                                            this.isCheck = true;
                                        } else {
                                            this.isCheck = false;
                                        }
                                    }
                                    this.next = res.data.next;
                                    this.prev = res.data.prev;
                                } else {
                                    this.$message.error(res.data.info);
                                }
                            });
                        })
                        .catch(() => {});
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //是否可以编辑修改(审核按钮)------------------------
        isEdit(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }

            apicheckMove({
                movesj_no: this.form.movesj_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                    this.searchIt(this.form.movesj_no);
                    this.$forceUpdate();
                } else {
                    this.$message.error(res.data.info);

                    this.searchIt(this.form.movesj_no);
                    this.$forceUpdate();
                }
            });
        },
        // 跳到第一页-------------------------------------------
        firstPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiFirstMove({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 跳到最后一页-------------------------------------------
        lastPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiLastMove({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 下一页-----------------------------------------------------
        nextPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiNextMove({
                movesj_no: this.form.movesj_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 上一页------------------------------------------
        prevPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrevMove({
                movesj_no: this.form.movesj_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },

        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            // await this.$refs.xTable1.setActiveCell(newRow, 'style_no');
            // this.$refs.stylefocus.focus();
        },
        //删除--------------------------------------------
        removeEvent() {
            let length = this.$refs.xTable1.getCheckboxRecords();
            if (length.length == 0) {
                this.$message.error('请选择你要删除的');
            } else {
                this.$XModal.confirm('您确定要删除该数据?').then((type) => {
                    if (type === 'confirm') {
                        this.$refs.xTable1.removeCheckboxRow();
                    }
                });
            }
        },
        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                this.insertEvent(-1);
            }
        },
        //放大图片---------------------------------------------
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file;
            this.dialogVisible = true;
        },
        //导出excel----------------------------------------
        showOut() {
            this.excelData.isshow = true;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        outExcel() {
            var name = this.username;
            this.excelData.isshow = false;
            this.$axios
                .get(this.$baseURL + 'movesj_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        login_staff: name,
                        movesj_no: this.keyword,
                        type: this.excelValue,
                        in_counter: this.in_counter,
                        out_counter: this.out_counter,
                        style_no: this.style_no,
                        movesj_date: this.subscribe_date
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '.xlsx';
                    link.click();
                });
            // }
        },
        //导出模板----------------------------------
        outTem() {
            this.$axios
                .get(this.$baseURL + 'movesj_template_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        type: this.excelValue
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '模板.xlsx';
                    link.click();
                });
        },
        //页面不可编辑时提示语
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },

        //列配置相关接口

        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '18';
            }
            this.drawers = true;
        },

        checkMove() {},

        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        getTable() {
            apiGetListCorrespondingData({
                id: '18'
            }).then((res) => {
                this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //计算金额小计
        countAmount(row) {
            var b = Number(row.qty || 0) * Number(row.qty_prc || 0) + Number(row.wgt || 0) * Number(row.wgt_prc || 0);
            row.amt = b.toFixed(this.systemSet.amt);
            return b;
        },
        countAllAmount(data) {
            return this.$utils.sum(data.map((row) => this.countAmount(row)));
        },
        // 折足重
        counttranswgt(row){
            if (row.unit_wgt && Number(row.unit_wgt) !== 0) {
                let wgt = this.$utils.multiply(Number(row.qty || 0), Number(row.unit_wgt || 0));
                row.wgt = Number(wgt).toFixed(this.systemSet.wgt);
            }
            let b = this.$utils.multiply(Number(row.wgt) || 0, Number(row.alloy) || 1);
            row.trans_wgt = Number(b).toFixed(this.systemSet.wgt);
            return b;
        },
        // 表尾合计---------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 1) {
                        return '合计';
                    }
                    if (column.property == 'wgt') {
                        this.form.sumwgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'qty') {
                        this.form.sumqty = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                    }else if (column.property == 'trans_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'amt') {
                        this.form.sumamt = `${this.countAllAmount(data).toFixed(this.systemSet.amt)} `;
                        return `${this.countAllAmount(data).toFixed(this.systemSet.amt)} `;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        choseIt(row) {
            var arr = [];
            for (let i in row.row.style_img) {
                if (row.row.style_img[i]) {
                    arr.push(row.row.style_img[i]);
                }
                this.imgArr = arr;
            }
        },
        selectIt(row) {
            //
            var newArr = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_no;
            });
            var newArr1 = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_no;
            });
            //
            if (row.row.style_no) {
                this.imgArr = newArr1[0].img;
                row.row.style_name = newArr[0].style_name;
            }
        },
        selectName(row) {
            var newArr = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_name;
            });
            var newArr1 = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_name;
            });
            if (row.row.style_name) {
                row.row.style_no = newArr[0].style_no;
                this.imgArr = newArr1[0].img;
            }
        },
        changeData(row, type, e) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }

            // var newArr = this.allArr.style.filter(function (obj) {
            //     return obj.style_no == row.style_no;
            // });
            // var newArr1 = this.allArr.style.filter(function (obj) {
            //     return obj.style_no == row.style_no;
            // });
            // if (row.style_no) {
            //     this.imgArr = newArr1[0].img;
            //     row.style_name = newArr[0].style_name;
            // }
            if (e == 'dtl') {
                if (type + '_no' == 'style_no') {
                    apiCustStyleWage({ cust_no: '', style_no: selectedNo, type: 'out' }).then((res) => {
                        if (res.code == 2000) {
                            for (var item in res.data) {
                                row[item] = res.data[item];
                            }
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                }
            }
        },
        dialogVisibleModify() {
            this.dialogFormVisible = false;
            this.$print(this.$refs.prints);
        },
        labelBarcodeDiyClick() {
            let selectedData = this.$refs.xTable1.getCheckboxRecords();
            let data = selectedData.length > 0 ? selectedData : this.form.dtl;
            let strBarcode = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strBarcode.push(data[i].barcode);
                }
            }
            let params = {
                barcodes: strBarcode.join(','),
                is_exports: 0,
                is_rfid: 0
            };
            apiLabelPrintPrintBarcodes(params).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //标签打印
        labelClick() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let idseq = [];
            data.forEach((item) => {
                    idseq.push(item.seq);
                });
                let subscribe_seq = idseq.join(',');
                apiPrintmovesjprintLabel({
                    movesj_no: this.form.movesj_no,
                    seq: subscribe_seq
                }).then((res) => {
                    if (res.code == 2000) {
                        this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            // if (data.length == 0) {
            //     this.$message.error('请选择调拨明细，进行标签打印');
            //     return;
            // } else {
            //     data.forEach((item) => {
            //         // idArr.push(item.movesj_no);
            //         idseq.push(item.seq);
            //     });
            //     // let movesj_no = idArr.join(',');
            //     let subscribe_seq = idseq.join(',');
            //     // this.dialogFormVisible = true;
            //     apiPrintmovesjprintLabel({
            //         movesj_no: this.form.movesj_no,
            //         seq: subscribe_seq
            //     }).then((res) => {
            //         if (res.code == 2000) {
            //             // this.LabelList = res.data;
            //             console.log(res);
            //             return
            //             this.$router.push({
            //             path: '/printingfusion',
            //             query: {
            //                 url: res.data.Url
            //             }
            //         });
            //         } else {
            //             this.$message.error(res.data.info);
            //         }
            //     });
            // }
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '32'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 筛选功能--------------------------------------------------
        showInput() {
            if (this.bonusData.field == null) this.bonusData.field = [];
            if (this.bonusData.table == null) this.bonusData.table = [];
            if (this.bonusData.condition == null) this.bonusData.condition = [];
            if (this.bonusData.parameter == null) this.bonusData.parameter = [];
            let inputValue = '';
            this.bonusData.field.push(inputValue);
            this.bonusData.table.push(inputValue);
            this.bonusData.condition.push(inputValue);
            this.bonusData.parameter.push(inputValue);
        },
        selectOne(index) {
            for (var i = 0; i < this.allArr.screen_pull.length; i++) {
                if (this.allArr.screen_pull[i].table == this.bonusData.field[index]) this.tableIndex = i;
            }
            this.arr[index] = this.tableIndex;
        },
        selectOne1(index) {
            for (var j = 0; j < this.allArr.screen_pull[this.arr[index]].field.length; j++) {
                if (this.allArr.screen_pull[this.arr[index]].field[j].name_no == this.bonusData.table[index]) this.tableNo = j;
            }
            this.arrs[index] = this.tableNo;
        },
        deleteRow(index, rows) {
            for (var i = 0; i < rows.field.length; i++) {
                //
                if (rows.table[i] == this.bonusData.table[index]) {
                    rows.field.splice(i, 1);
                    rows.table.splice(i, 1);
                    rows.condition.splice(i, 1);
                    rows.parameter.splice(i, 1);
                }
            }
            // rows.splice(index, 1);
        },
        // 确认筛选-------------------------------------------------
        saveOk() {
            //
            var arrBig = [];
            for (
                var i = 0;
                i < this.bonusData.field.length &&
                this.bonusData.table.length &&
                this.bonusData.condition.length &&
                this.bonusData.parameter.length;
                i++
            ) {
                arrBig[i] = {};
                arrBig[i].table = this.bonusData.field[i];
                arrBig[i].field = this.bonusData.table[i];
                arrBig[i].condition = this.bonusData.condition[i];
                arrBig[i].parameter = this.bonusData.parameter[i];
            }
            apichooseMove({
                data: arrBig
            }).then((res) => {
                if (res.code == 2000) {
                    this.searchData = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 自定义下拉框搜索方法
        searchCounter(val) {
            // val=val.toUpperCase()
            this.form.out_counter = val;
            if (val) {
                var len = this.allArr.counter;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (
                        len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
                        len[i].kind_name.toLowerCase().indexOf(val.toLowerCase()) >= 0
                    ) {
                        arr.push(len[i]);
                    }
                }
                this.pull_counter = arr;
            } else {
                this.pull_counter = this.allArr.counter;
            }
        },
        searchCounter2(val) {
            // val=val.toUpperCase()
            this.form.in_counter = val;
            if (val) {
                var len = this.allArr.counter;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (
                        len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
                        len[i].kind_name.toLowerCase().indexOf(val.toLowerCase()) >= 0
                    ) {
                        arr.push(len[i]);
                    }
                }
                this.pull_counter2 = arr;
            } else {
                this.pull_counter2 = this.allArr.counter;
            }
        },
        refreshs() {
            this.$forceUpdate();
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 打印-----------------------
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('调拨单.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        // 打印
        printOut() {
            this.getPulls();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintMover({
                movesj_no: this.form.movesj_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            this.query.model_name = val;
            this.printOutTwo();
            this.$forceUpdate();
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintMover({
                movesj_no: this.form.movesj_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.printList = res.data.dtl;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    // this.$message.error(res.data.info);
                    this.printOut();
                }
            });
        },
        //批量审核
        saveCheck(check) {
            let data = this.checkData.data;
            apiMoverAllCheck({
                begin_date: data.begin_date,
                end_date: data.end_date,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.searchIt(this.form.movesj_no);
                    this.checkData.isshow = false;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        getRefreshPull() {
            this.pull_counter = this.allArr.outcounter;
            this.pull_counter2 = this.allArr.incounter;
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },

        // 新增入库明细
        adddtl() {
            this.insertEvent(-1);
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        goHistory() {
            this.$router.push({ path: '/moveHistory', query: { page: 'movemanage' } });
        },
        selectkey() {},
        //    获取重量电子秤数据
        getSetScale(row, type) {
            setScale({
                random: 'BF-202212020941'
            }).then((res) => {
                row[type] = res.data;
            });
        },
        handleInput(row, field, type) {
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;

            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().tableData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            if (e.keyCode == 113) {
                if (type != 'outcounter_no' && type != 'outcounter_no' && type != 'incounter_no') {
                    this.getSetScale(row, type);
                }
            }
            //问题1：回车键最后一条不需要输入的列处理
            //问题2：无法确定一个有几个需要跳过的列
            var addnum = 1; //跳过列的基本参数，每一个需要跳过的加1
            var addnumleft = 1;
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            // 右移;
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }
            // 左移
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }

            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().tableData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    // 跳转到下一列
                    this.$refs.xTable1.setActiveCell(row, downtype);
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>
<style scoped lang="scss">
/deep/.vxe-footer--row {
    font-weight: 600;
}
/* 修改样式 */
.head_warpper {
    box-sizing: border-box;
}

/* 修改样式 */
</style>
<style scoped>
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
</style>
<style>
.printBox table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}
.printBox table td,
.printBox table th {
    border: 1px solid #000;
}
.printBox table th {
    font-weight: bold;
    color: #000;
}
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.printTitle {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    letter-spacing: 5px;
}
.printTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid rgb(7, 16, 114);
}
.printTop div label {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 15px;
}
.printTop div p {
    line-height: 1.25;
}
.printBox .tableName {
    font-size: 12px;
    padding: 2px 0;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.oversummoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15% 0 0;
    /* border-bottom: 1px solid #000; */
}
.oversummoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 15px;
}
.oversummoney .sum1 span:nth-child(2) {
    font-size: 15px;
    color: #000;
    margin-left: 20px;
}
.sumBotn {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 5px 0;
}
.sumBotn p span {
    font-size: 15px;
    color: #000;
}
.sumBotn div span:first-child {
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.img {
    padding-right: 5px;
}
.img .el-upload {
    width: 150px;
    height: 150px;
    line-height: 150px;
}
.pro .el-upload--text {
    width: auto;
    height: auto;
    border: none;
}
.batchBtn {
    margin-left: 5px;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #409eff !important;
}
.modify {
    padding-right: 20px;
}
.modify .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
.modify .el-form-item__label {
    padding: 0 0 0 0;
}
.modify .el-input__inner {
    border: none;
    border-radius: 0;
    color: #409eff !important;
    padding: 0 0;
}
.modify .el-input.is-disabled .el-input__inner {
    background-color: #fff;
}
.checkboxProMove {
    margin-top: 5px;
    float: right;
    margin-left: 10px;
}
.checkboxProMove input[type='checkbox'] {
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    position: relative;
}
.checkboxProMove input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
}
.checkboxProMove input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #fff;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    border: 1px solid #e50232;
    color: #e50232;
    font-size: 17px;
    font-weight: bold;
}
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.el-select {
    width: 100%;
}
.move22 tr.vxe-header--row:first-child {
    background: rgb(64, 128, 128);
    color: #fff;
}
.movemanger {
    padding-bottom: 65px;
    box-sizing: border-box;
}
.movemanger .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
.movemanger .vxe-table .vxe-body--column.col--ellipsis,
.movemanger .vxe-table.vxe-editable .vxe-body--column,
.movemanger .vxe-table .vxe-footer--column.col--ellipsis,
.movemanger .vxe-table .vxe-header--column.col--ellipsis {
    height: 38px;
}
</style>
<style scoped lang="scss">
.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }
        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
